import { gql as r, InMemoryCache as Ue, ApolloLink as Y, split as X, from as R, ApolloProvider as we } from "@apollo/client";
import { ApolloConsumer as dr, ApolloError as cr, ApolloProvider as lr, NetworkStatus as mr, gql as ur, useApolloClient as pr, useLazyQuery as fr, useMutation as gr, useQuery as $r, useSubscription as Ir } from "@apollo/client";
import { GraphQLWsLink as Z } from "@apollo/client/link/subscriptions";
import { createClient as ee } from "graphql-ws";
import { setContext as T } from "@apollo/client/link/context";
import { getMainDefinition as te } from "@apollo/client/utilities";
import { ApolloLink as De } from "@apollo/client/link/core/ApolloLink.js";
import { createSignalIfSupported as _e } from "@apollo/client/link/http/createSignalIfSupported.js";
import { parseAndCheckHttpResponse as Pe } from "@apollo/client/link/http/parseAndCheckHttpResponse.js";
import { rewriteURIForGET as Ce } from "@apollo/client/link/http/rewriteURIForGET.js";
import { selectHttpOptionsAndBodyInternal as Fe, defaultPrinter as Te, fallbackHttpConfig as Me } from "@apollo/client/link/http/selectHttpOptionsAndBody.js";
import { selectURI as Ae } from "@apollo/client/link/http/selectURI.js";
import { serializeFetchParameter as Q } from "@apollo/client/link/http/serializeFetchParameter.js";
import { Observable as z } from "@apollo/client/utilities/observables/Observable.js";
import Ee from "axios";
import { ApolloClient as Re } from "@apollo/client/core/ApolloClient";
import { jsx as je } from "react/jsx-runtime";
import { useState as xe, useEffect as Ne } from "react";
function Oe(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ve(e, t, o = "") {
  if (!arguments.length) throw new TypeError("Argument 1 `value` is required.");
  if (typeof t != "function")
    throw new TypeError("Argument 2 `isExtractable` must be a function.");
  if (typeof o != "string")
    throw new TypeError("Argument 3 `path` must be a string.");
  const a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  function u(c, g, b) {
    if (t(c)) {
      const f = s.get(c);
      return f ? f.push(g) : s.set(c, [g]), null;
    }
    const y = Array.isArray(c) || typeof FileList < "u" && c instanceof FileList, k = Oe(c);
    if (y || k) {
      let f = a.get(c);
      const i = !f;
      if (i && (f = y ? [] : (
        // Replicate if the plain object is an `Object` instance.
        c instanceof /** @type {any} */
        Object ? {} : /* @__PURE__ */ Object.create(null)
      ), a.set(
        c,
        /** @type {Clone} */
        f
      )), !b.has(c)) {
        const n = g ? `${g}.` : "", d = new Set(b).add(c);
        if (y) {
          let m = 0;
          for (const B of c) {
            const $ = u(
              B,
              n + m++,
              d
            );
            i && f.push($);
          }
        } else
          for (const m in c) {
            const B = u(
              c[m],
              n + m,
              d
            );
            i && (f[m] = B);
          }
      }
      return f;
    }
    return c;
  }
  return {
    clone: u(e, o, /* @__PURE__ */ new Set()),
    files: s
  };
}
function qe(e, t, o) {
  "name" in o ? e.append(t, o, o.name) : e.append(t, o);
}
function Le(e) {
  return typeof File < "u" && e instanceof File || typeof Blob < "u" && e instanceof Blob;
}
function re({
  uri: e = "/graphql",
  useGETForQueries: t,
  isExtractableFile: o = Le,
  FormData: a,
  formDataAppendFile: s = qe,
  print: u = Te,
  fetch: c,
  fetchOptions: g,
  credentials: b,
  headers: y,
  includeExtensions: k
} = {}) {
  const f = {
    http: { includeExtensions: k },
    options: g,
    credentials: b,
    headers: y
  };
  return new De((i) => {
    const n = (
      /**
       * @type {import("@apollo/client/core/types.js").DefaultContext & {
       *   clientAwareness?: {
       *     name?: string,
       *     version?: string,
       *   },
       * }}
       */
      i.getContext()
    ), {
      // Apollo Studio client awareness `name` and `version` can be configured
      // via `ApolloClient` constructor options:
      // https://www.apollographql.com/docs/graphos/metrics/client-awareness/#setup
      clientAwareness: { name: d, version: m } = {},
      headers: B
    } = n, $ = {
      http: n.http,
      options: n.fetchOptions,
      credentials: n.credentials,
      headers: {
        // Client awareness headers can be overridden by context `headers`.
        ...d && { "apollographql-client-name": d },
        ...m && { "apollographql-client-version": m },
        ...B
      }
    }, { options: l, body: v } = Fe(
      i,
      u,
      Me,
      f,
      $
    ), { clone: q, files: M } = ve(v, o, "");
    let A = Ae(i, e);
    if (M.size) {
      l.headers && delete l.headers["content-type"];
      const I = a || FormData, h = new I();
      h.append("operations", Q(q, "Payload"));
      const p = {};
      let E = 0;
      M.forEach((L) => {
        p[++E] = L;
      }), h.append("map", JSON.stringify(p)), E = 0, M.forEach((L, Se) => {
        s(h, String(++E), Se);
      }), l.body = h;
    } else if (t && // If the operation contains some mutations GET shouldn’t be used.
    !i.query.definitions.some(
      (I) => I.kind === "OperationDefinition" && I.operation === "mutation"
    ) && (l.method = "GET"), l.method === "GET") {
      const { newURI: I, parseError: h } = Ce(A, v);
      if (h)
        return new z((p) => {
          p.error(h);
        });
      A = I;
    } else l.body = Q(q, "Payload");
    const { controller: U } = _e();
    typeof U != "boolean" && (l.signal && (l.signal.aborted ? (
      // Signal already aborted, so immediately abort.
      U.abort()
    ) : (
      // Signal not already aborted, so setup a listener to abort when it
      // does.
      l.signal.addEventListener(
        "abort",
        () => {
          U.abort();
        },
        {
          // Prevent a memory leak if the user configured abort controller
          // is long lasting, or controls multiple things.
          once: !0
        }
      )
    )), l.signal = U.signal);
    const Be = c || fetch;
    return new z((I) => {
      let h;
      return Be(A, l).then((p) => (i.setContext({ response: p }), p)).then(Pe(i)).then((p) => {
        I.next(p), I.complete();
      }).catch((p) => {
        h || (p.result && p.result.errors && p.result.data && I.next(p.result), I.error(p));
      }), () => {
        h = !0, typeof U != "boolean" && U.abort();
      };
    });
  });
}
const j = "mage-cache-storage";
class w extends Error {
}
w.prototype.name = "InvalidTokenError";
function Qe(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, o) => {
    let a = o.charCodeAt(0).toString(16).toUpperCase();
    return a.length < 2 && (a = "0" + a), "%" + a;
  }));
}
function ze(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Qe(t);
  } catch {
    return atob(t);
  }
}
function We(e, t) {
  if (typeof e != "string")
    throw new w("Invalid token specified: must be a string");
  t || (t = {});
  const o = t.header === !0 ? 0 : 1, a = e.split(".")[o];
  if (typeof a != "string")
    throw new w(`Invalid token specified: missing part #${o + 1}`);
  let s;
  try {
    s = ze(a);
  } catch (u) {
    throw new w(`Invalid token specified: invalid base64 for part #${o + 1} (${u.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (u) {
    throw new w(`Invalid token specified: invalid json for part #${o + 1} (${u.message})`);
  }
}
function W(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
const He = 6e4;
function Je(e) {
  return (t) => {
    const a = (e ? Math[e] : Math.trunc)(t);
    return a === 0 ? 0 : a;
  };
}
function Ke(e, t) {
  return +W(e) - +W(t);
}
function oe(e, t, o) {
  const a = Ke(e, t) / He;
  return Je(o?.roundingMethod)(a);
}
const Ge = (e, t) => window.localStorage.setItem(e, t), Ve = (e) => window.localStorage.getItem(e), Ye = (e) => window.localStorage.removeItem(e), S = {
  setItem: Ge,
  getItem: Ve,
  removeItem: Ye
}, ae = (e) => We(e)?.expired_at, Xe = (e) => {
  try {
    const t = ae(e), o = (/* @__PURE__ */ new Date()).toISOString();
    return new Date(t) < new Date(o);
  } catch {
    return !0;
  }
}, Ze = (e) => {
  try {
    const t = ae(e);
    let o = 0;
    if (t) {
      const a = (/* @__PURE__ */ new Date()).toISOString();
      o = oe(t, new Date(a));
    }
    return o < 5;
  } catch {
    return !0;
  }
}, et = () => S.getItem(j) ? JSON.parse(S.getItem(j))?.customer?.signin_token : "", tt = Ee.create();
function rt() {
  return JSON.parse(S.getItem(j) || "{}")?.customer || {};
}
async function ie() {
  const e = rt();
  if (e?.customer_id)
    return Promise.resolve(e.customer_id);
  try {
    return (await ot())?.data?.id ?? "";
  } catch (t) {
    return console.error("Error while fetching customer", t), "";
  }
}
function ot() {
  return tt("rest/default/V1/customers/me", {
    baseURL: "/",
    method: "GET",
    withCredentials: !0,
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
}
const at = {
  en: "en",
  fr: "fr",
  de: "de",
  it: "it",
  es: "es"
}, ne = () => {
  const e = location.pathname.replace(/^\/+/g, "").split("/")[0];
  return at[e];
};
function it(e) {
  const t = Object.fromEntries(
    document.cookie.split("; ").map((o) => o.split("="))
  );
  return t[e] ? decodeURIComponent(t[e]) : null;
}
function se() {
  return it("loggedIn");
}
const nt = [
  "countries",
  "projectUsers",
  "projectUserSuggestions",
  "notes",
  "types",
  "phases",
  "project",
  "projectByExternalID",
  "projects"
], st = [
  "createProjectUser",
  "updateProjectUser",
  "deleteProjectUser",
  "Auth",
  "createNote",
  "updateNote",
  "deleteNote",
  "readNotes",
  "evaluateTypes",
  "createProject",
  "patchProject",
  "deleteProject",
  "transferProject"
], dt = [
  "healthcheck",
  "watchNotes",
  "watchNotesSummary"
], ct = [
  ...dt,
  ...st,
  ...nt
], H = {
  "materialbank.test": "http://localhost:8081",
  "dev.materialbank.com": "https://mb-projects-dev.usw2.materialbank.com",
  "stage2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-projects-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-projects-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://projects.p.materialbank.eu",
  "www.materialbank.com": "https://projects.p.materialbank.com",
  default: "https://mb-projects-uat.usw2.materialbank.com"
}, de = "projects.accessToken";
function x(e, t) {
  S.setItem(
    de,
    JSON.stringify({
      [t]: e
    })
  );
}
function lt() {
  try {
    return JSON.parse(S.getItem(de) ?? "{}");
  } catch {
    return {};
  }
}
const J = "private-content-loaded", ce = async (e) => {
  let t = et();
  return t || (t = await new Promise((o) => {
    const a = (s) => {
      const u = s;
      window.removeEventListener(J, a);
      const c = u.detail.data;
      o(c.customer.signin_token);
    };
    window.addEventListener(J, a);
  })), fetch(e, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        mutation Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: t
      }
    })
  });
}, mt = async (e, t) => {
  try {
    const s = (await (await ce(e)).json()).data.Auth?.token || "";
    return x(s, t), s;
  } catch (o) {
    return console.error(o), "";
  }
}, ut = (e, t) => {
  ce(e).then(
    (o) => {
      o.json().then((a) => {
        const s = a.data.Auth?.token || "";
        x(s, t);
      });
    },
    (o) => {
      console.error(o), x("", t);
    }
  );
}, pt = () => {
  const e = window.location.hostname;
  return H[e] ?? H.default;
}, ft = [
  "Auth",
  "Board",
  "BoardOwnerDetails",
  "BoardProjects",
  "BoardUsers",
  "Boards",
  "ConsideringSampledBoard",
  "ConsideringSampledBoardBrands",
  "ConsideringSampledBoardItems",
  "ConsideringSampledBoards",
  "ItemFilters",
  "ItemNotes",
  "Items",
  "ItemsCount",
  "MaterialExport",
  "MaterialExportTemplates",
  "Moodboard",
  "MoodboardComments",
  "PinterestBoards",
  "PinterestPinsOnBoard",
  "PublicBoard",
  "PublicMaterialExport",
  "RenewToken",
  "Tags"
], gt = [
  "archiveMoodboardThreads",
  "checkConsideringSampledBoard",
  "copyBoard",
  "copyItem",
  "copyMoodboard",
  "createBoard",
  "createBoardUser",
  "createItem",
  "createItemNote",
  "createItems",
  "createMaterialExportTemplate",
  "createMoodboard",
  "createMoodboardComment",
  "createRepOrder",
  "deleteBoard",
  "deleteBoardProduct",
  "deleteBoardUser",
  "deleteItem",
  "deleteItemNote",
  "deleteMaterialExportTemplate",
  "deleteMoodboard",
  "deleteMoodboardComment",
  "pinterestAuthExchangeCode",
  "pinterestAuthRefreshToken",
  "readItemNotes",
  "removeBackgroundForMoodBoard",
  "unarchiveMoodboardThreads",
  "updateBoard",
  "updateBoardUser",
  "updateConsideringSampledBoardBrand",
  "updateItem",
  "updateItemNote",
  "updateItems",
  "updateMaterialExportTemplate",
  "updateMoodboard",
  "updateMoodboardComment",
  "updateSampledBrands"
], $t = [
  "healthcheck",
  "watchBoardSummary",
  "watchItemNotes",
  "watchMoodboardComments",
  "watchMoodboardSummary"
], It = [
  ...$t,
  ...gt,
  ...ft
], bt = {
  appDataStorageKey: "mage-cache-storage"
}, { appDataStorageKey: K } = bt, G = {
  "materialbank.test": "http://localhost:8080",
  "dev.materialbank.com": "https://mb-boards-dev.usw2.materialbank.com",
  "uat2.materialbank.com": "https://mb-boards-uat.usw2.materialbank.com",
  "uat.materialbank.eu": "https://mb-boards-uat.dev.materialbank.eu",
  "www.materialbank.eu": "https://boards.p.materialbank.eu",
  "www.materialbank.com": "https://boards.p.materialbank.com",
  default: "https://mb-boards-uat.usw2.materialbank.com"
};
r`
  mutation ArchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    archiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
r`
  mutation CheckConsideringBoard($id: UUID!) {
    checkConsideringSampledBoard(id: $id) {
      id
    }
  }
`;
r`
  mutation CopyBoard($id: UUID!) {
    copyBoard(id: $id) {
      name
    }
  }
`;
r`
  mutation CopyMoodboardMutation($id: UUID!) {
    copyMoodboard(id: $id) {
      id
      name
    }
  }
`;
r`
  mutation CopyToBoardMutation($id: UUID!, $boardId: UUID!) {
    copyItem(id: $id, boardId: $boardId) {
      id
    }
  }
`;
r`
  mutation CreateBoard($input: createBoard!) {
    createBoard(input: $input) {
      name
      slug
    }
  }
`;
r`
  mutation CreateBoardUser($boardId: UUID!, $input: createBoardUser!) {
    createBoardUser(boardId: $boardId, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
r`
  mutation CreateItemMutation($boardId: UUID!, $input: ItemInput!) {
    createItem(boardId: $boardId, input: $input) {
      id
      name
      type
    }
  }
`;
r`
  mutation CreateItemNoteMutation($itemId: UUID!, $input: ItemNoteInput!) {
    createItemNote(itemId: $itemId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation CreateItemsMutation($boardId: UUID!, $input: [ItemInput!]!) {
    createItems(boardId: $boardId, input: $input) {
      id
      name
      type
    }
  }
`;
r`
  mutation CreateMaterialExportTemplate(
    $input: CreateMaterialExportTemplateInput!
  ) {
    createMaterialExportTemplate(input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  mutation CreateMoodboardCommentMutation(
    $moodboardId: UUID!
    $input: createMoodboardComment!
  ) {
    createMoodboardComment(moodboardId: $moodboardId, input: $input) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation CreateMoodboardMutation($boardID: UUID!, $input: MoodboardInput!) {
    createMoodboard(boardID: $boardID, input: $input) {
      id
      name
    }
  }
`;
r`
  mutation CreateRepOrderMutation(
    $token: String!
    $input: CreateRepOrderInput!
  ) {
    createRepOrder(token: $token, input: $input) {
      orderId
      orderNumber
      deliveryMessage
    }
  }
`;
r`
  mutation DeleteBoardProduct($boardId: UUID!, $productRef: Int!) {
    deleteBoardProduct(boardId: $boardId, productRef: $productRef) {
      id
    }
  }
`;
r`
  mutation DeleteBoardItemMutation($id: UUID!) {
    deleteItem(id: $id) {
      id
    }
  }
`;
r`
  mutation DeleteBoard($id: UUID!) {
    deleteBoard(id: $id)
  }
`;
r`
  mutation DeleteBoardUser($id: UUID!) {
    deleteBoardUser(id: $id)
  }
`;
r`
  mutation DeleteItemNoteMutation($noteId: UUID!) {
    deleteItemNote(noteId: $noteId) {
      id
      isPublic
    }
  }
`;
r`
  mutation DeleteMaterialExportTemplate($id: UUID!) {
    deleteMaterialExportTemplate(id: $id)
  }
`;
r`
  mutation DeleteMoodboardCommentMutation($commentId: UUID!) {
    deleteMoodboardComment(commentId: $commentId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation DeleteMoodboardMutation($id: UUID!) {
    deleteMoodboard(id: $id) {
      id
    }
  }
`;
r`
  mutation RemoveBackgroundForMoodBoardMutation(
    $moodboardId: UUID!
    $imageUrl: String!
  ) {
    removeBackgroundForMoodBoard(moodboardId: $moodboardId, imageUrl: $imageUrl)
  }
`;
r`
  mutation PinterestAuthExchangeCode($code: String!, $redirectUri: String!) {
    pinterestAuthExchangeCode(code: $code, redirectUri: $redirectUri) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
r`
  mutation PinterestAuthRefreshToken($refreshToken: String!) {
    pinterestAuthRefreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      responseType
      tokenType
      expiresIn
      refreshTokenExpiresIn
      scope
    }
  }
`;
r`
  mutation ReadItemNotes($itemId: UUID!) {
    readItemNotes(itemId: $itemId)
  }
`;
r`
  mutation UnarchiveMoodboardThreadsMutation(
    $moodboardId: UUID!
    $threadIds: [UUID!]!
  ) {
    unarchiveMoodboardThreads(moodboardId: $moodboardId, threadIds: $threadIds)
  }
`;
r`
  mutation UpdateBoardMutation($id: UUID!, $input: updateBoard!) {
    updateBoard(id: $id, input: $input) {
      id
      name
      description
      projectRef
      publicRef
      showOwnerDetails
      distributeToReps
      type
      activeMoodboardId
    }
  }
`;
r`
  mutation UpdateBoardUser($id: UUID!, $input: updateBoardUser!) {
    updateBoardUser(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      unregisteredEmail
      type
    }
  }
`;
r`
  mutation UpdateItemMutation($id: UUID!, $input: ItemInput!) {
    updateItem(id: $id, input: $input) {
      id
      position
      name
      status
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
    }
  }
`;
r`
  mutation UpdateItemNoteMutation($noteId: UUID!, $input: ItemNoteInput!) {
    updateItemNote(noteId: $noteId, input: $input) {
      id
      isPublic
      note
      createdAt
      updatedAt
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
    }
  }
`;
r`
  mutation UpdateItemsMutation($input: [ItemInput!]) {
    updateItems(input: $input) {
      id
      position
      name
      status
      attributes {
        name
        value
      }
      tags {
        id
        name
      }
    }
  }
`;
r`
  mutation UpdateMaterialExportTemplate(
    $id: UUID!
    $input: UpdateMaterialExportTemplateInput!
  ) {
    updateMaterialExportTemplate(id: $id, input: $input) {
      id
      name
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  mutation UpdateMoodboardCommentMutation(
    $commentId: UUID!
    $comment: String!
  ) {
    updateMoodboardComment(commentId: $commentId, comment: $comment) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  mutation UpdateMoodboardMutation($id: UUID!, $input: MoodboardInput!) {
    updateMoodboard(id: $id, input: $input) {
      id
      name
      payload
    }
  }
`;
r`
  mutation UpdateSampledBrandsMutation(
    $boardId: UUID!
    $brands: [String!]!
    $status: BrandStatus!
  ) {
    updateSampledBrands(boardId: $boardId, brands: $brands, status: $status) {
      name
    }
  }
`;
r`
  mutation UpdateSampledBrandsMutation(
    $boardId: UUID!
    $brands: [String!]!
    $status: BrandStatus!
  ) {
    updateSampledBrands(boardId: $boardId, brands: $brands, status: $status) {
      name
      logo
      status
    }
  }
`;
const le = r`
  fragment BoardDetails on Board {
    id
    itemsCount(filter: $filter)
  }
`;
r`
  ${le}

  query BoardDetailsQuery($slug: String!, $filter: ItemFilterInput) {
    Board(slug: $slug) {
      ...BoardDetails
    }
  }
`;
r`
  ${le}

  query PublicBoardDetailsQuery($token: String!, $filter: ItemFilterInput) {
    PublicBoard(token: $token) {
      ...BoardDetails
    }
  }
`;
const yt = r`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, me = r`
  fragment BoardItemFields on Item {
    id
    type
    name
    imageUrl
    description
    position
    sampled
    source
    status
    associatedProduct {
      _id
      imageUrl
      name
      manufacturer
    }
    attributes {
      name
      value
    }
    tags {
      id
      name
    }
    product {
      ...ProductFields
    }
  }
  ${yt}
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
    $filter: BoardFilterInput
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemFilter: ItemFilterInput
    $itemPage: Int
    $itemPageSize: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
      filter: $filter
    ) {
      id
      name
      slug
      projectRef
      publicRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      itemsCount(filter: $itemFilter)
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${me}
`;
r`
  query PublicBoardItemsQuery(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    PublicBoard(token: $slug) {
      id
      name
      slug
      publicRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${me}
`;
const ue = r`
  fragment BoardDetails on Board {
    id
    name
    type
    archived
    name
    projectRef
    description
    publicRef
    permission
    showOwnerDetails
    distributeToReps
    coverUrl
    hasCustomCover
    coverItemRef
    tags {
      id
      name
    }
    moodboards {
      id
      name
    }
    activeMoodboardId
    itemsPaginated(sortBy: $sort) {
      items {
        id
        type
        name
        imageUrl
        description
        position
        sampled
        source
        status
        associatedProduct {
          _id
          imageUrl
          name
          manufacturer
        }
        attributes {
          name
          value
        }
        tags {
          id
          name
        }
        product {
          _id
          entity_id
          name
          url
          brand_product
          price_sign
          manufacturer
          residential_commercial
          associated_finish_products
          imageUrl
          thumbnailImageUrl
          ss_item_type
          family_id
          sku
          ss_facet_color_filter {
            entity_id
          }
          categories
          taxonomy_l2
          taxonomy_l3
          taxonomy_l4
          install_images
          qty
          components {
            items {
              name
            }
          }
          product_finish_type
          is_orderable
          is_digital
          status
          install_images
          is_gps_compliant
          country_permission
          state_permission
          project_type_restrictions
          primary_child_id
          color_variants {
            items {
              entity_id
              is_unavailable
            }
          }
        }
      }
    }
  }
`;
r`
  ${ue}

  query BoardDetailsQuery($slug: String!, $sort: ItemSortableField) {
    Board(slug: $slug) {
      ...BoardDetails
    }
  }
`;
r`
  ${ue}

  query PublicBoardDetailsQuery($slug: String!, $sort: ItemSortableField) {
    PublicBoard(token: $slug) {
      ...BoardDetails
    }
  }
`;
const ht = r`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, kt = r`
  fragment BoardItemFields on Item {
    id
    type
    name
    imageUrl
    description
    position
    sampled
    source
    status
    associatedProduct {
      _id
      imageUrl
      name
      manufacturer
    }
    attributes {
      name
      value
    }
    tags {
      id
      name
    }
    product {
      ...ProductFields
    }
  }
  ${ht}
`;
r`
  query BoardDetails(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    Board(slug: $slug) {
      id
      name
      slug
      publicRef
      projectRef
      showOwnerDetails
      permission
      itemFilters {
        statuses
        tags
        brands
      }
      type
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${kt}
`;
r`
  query BoardDetailsTagsQuery($slug: String!) {
    Board(slug: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
r`
  query PublicBoardDetailsTagsQuery($slug: String!) {
    PublicBoard(token: $slug) {
      tags {
        id
        name
      }
    }
  }
`;
const Bt = r`
  fragment ProductFields on Product {
    _id
    entity_id
    name
    url
    brand_product
    price_sign
    manufacturer
    residential_commercial
    associated_finish_products
    imageUrl
    thumbnailImageUrl
    ss_item_type
    family_id
    sku
    ss_facet_color_filter {
      entity_id
    }
    categories
    taxonomy_l2
    taxonomy_l3
    taxonomy_l4
    install_images
    qty
    components {
      items {
        name
      }
    }
    product_finish_type
    is_orderable
    is_digital
    status
    install_images
  }
`, pe = r`
  fragment BoardItemFields on Item {
    id
    status
    associatedProduct {
      name
      manufacturer
    }
    associatedProductRef
    product {
      ...ProductFields
    }
  }
  ${Bt}
`;
r`
  query BoardItemsQuery(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    Board(slug: $slug) {
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        totalPages
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${pe}
`;
r`
  query BoardItemsQueryPublic(
    $slug: String!
    $itemSort: ItemSortableField
    $itemSortDirection: ItemSortDirection
    $itemPage: Int
    $itemPageSize: Int
    $itemFilter: ItemFilterInput
  ) {
    PublicBoard(token: $slug) {
      itemsPaginated(
        sortBy: $itemSort
        sortDirection: $itemSortDirection
        page: $itemPage
        pageSize: $itemPageSize
        filter: $itemFilter
      ) {
        items {
          ...BoardItemFields
        }
      }
    }
  }
  ${pe}
`;
r`
  query BoardOwnerDetailsQuery($boardId: UUID!) {
    BoardOwnerDetails(boardId: $boardId) {
      firstName
      lastName
      companyName
      location
      imageUrl
      rep
      email
    }
  }
`;
r`
  query BoardProjects {
    BoardProjects
  }
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
    ) {
      id
      name
      slug
    }
  }
`;
r`
  query BoardsQuery(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $brandRef: String
    $limit: Int
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      brandRef: $brandRef
      limit: $limit
      filter: $filter
    ) {
      id
      name
      slug
      projectRef
      archived
      itemsCount
      covers
      coverUrl
      hasCustomCover
      publicRef
      permission
      type
      showOwnerDetails
      distributeToReps
      itemsPaginated {
        items {
          id
          name
          imageUrl
          product {
            categories
            url
            _id
            country_permission
            entity_id
            family_id
            image_scale_factor
            indoor_outdoor_use
            is_collection
            is_new
            is_orderable
            is_primary
            just_added
            is_digital
            light_reflectance_value
            manufacturer
            manufacturer_alias
            manufacturer_sku
            ss_item_type
            status
          }
        }
      }
    }
  }
`;
r`
  query BoardsQueryWithFilters(
    $sort: BoardsSortableField
    $order: Order
    $projectRef: String
    $archived: Boolean
    $filter: BoardFilterInput
  ) {
    Boards(
      sort: $sort
      order: $order
      projectRef: $projectRef
      archived: $archived
      filter: $filter
    ) {
      id
      name
      itemsPaginated {
        items {
          id
          product {
            entity_id
          }
        }
      }
    }
  }
`;
r`
  query BoardUsersQuery($boardId: UUID!) {
    BoardUsers(boardId: $boardId) {
      id
      userRef
      firstName
      lastName
      email
      type
      unregisteredEmail
      isEditable
      source
    }
  }
`;
r`
  query ConsideringSampledBoardItemsQuery(
    $boardId: UUID!
    $brands: [String!]!
  ) {
    ConsideringSampledBoardItems(boardId: $boardId, brands: $brands) {
      id
      name
      imageUrl
      status
      product {
        _id
        entity_id
        manufacturer
        categories
        taxonomy
        taxonomy_l2
        taxonomy_l3
        taxonomy_l4
        color
      }
    }
  }
`;
r`
  query ConsideringSampledBoardQuery(
    $from: Int!
    $to: Int!
    $projectCreatedBefore: Int!
    $lastCheckedBefore: Int!
    $sampledBrandsLimit: Int
    $sampledBrandsFilter: SampledBrandFilterInput
  ) {
    ConsideringSampledBoard(
      from: $from
      to: $to
      projectCreatedBefore: $projectCreatedBefore
      lastCheckedBefore: $lastCheckedBefore
    ) {
      id
      projectRef
      sampledBrands(limit: $sampledBrandsLimit, filter: $sampledBrandsFilter) {
        name
      }
    }
  }
`;
r`
  query ConsideringSampledBoardQuery($from: Int!, $to: Int!) {
    ConsideringSampledBoards(from: $from, to: $to) {
      checkedEligible {
        id
        projectRef
      }
      uncheckedEligible {
        id
        projectRef
      }
      nonEligible {
        id
        projectRef
      }
    }
  }
`;
r`
  query ItemFilters($boardId: UUID!) {
    ItemFilters(boardId: $boardId) {
      statuses
      tags
      brands
    }
  }
`;
r`
  query ItemNotesQuery($itemId: UUID!) {
    ItemNotes(itemId: $itemId) {
      id
      isPublic
      note
      user {
        firstName
        lastName
        imageUrl
        userRef
      }
      updatedAt
      createdAt
    }
  }
`;
r`
  query ItemsCount($boardId: UUID!, $filter: ItemFilterInput) {
    ItemsCount(boardId: $boardId, filter: $filter)
  }
`;
const fe = r`
  fragment ProjectInfoFields on MaterialExportProjectInfo {
    title
    description
    phaseLabel
  }
`, ge = r`
  fragment RowFields on MaterialExportRow {
    id
    name
    manufactureSku
    brand
    indoorOutdoorUse
    urlKey
    residentialCommercial
    color
    primaryColor
    collectionName
    contentTextile
    priceSign
    patternScale
    finishTreatment
    stainResistance
    durability
    carpetDyeMethod
    flammabilityTest
    thicknessPileHeightCarpet
    tags
    abrasionWearResistance
    acoustics
    ada
    classification
    emissions
    flammability
    slipResistance
    globalWarmingPotential
    width
    tileType
    contentTestAttribute
    construction
    categories
    colorNumber
    products
    paintProductType
    backingInput
    carpetFiberSystem
    csiNumber
    leed
    sustainabilityActionPlan
    organizationalCommitments
    multiAttributeCertification
    multiAttributeCertExpiration
    epd
    epdExpirationDate
    gwpUom
    lcaPlan
    postIndustrialRecycledContent
    postConsumerRecycledContent
    biobasedContent
    biobasedCertification
    manufacturingLocation
    eolOptions
    fscCertifiedWood
    vocEmissionsCertificate
    vocEmissionsTest
    vocTestExpirationDate
    ingredientDisclosure
    disclosureCertExpirationDate
    disclosureLevel
    ingredientsDisclosed75
    materialHealthCertifications
    materialHealthExpirationDate
    chemicalsOfConcern
    rohs
    electronicComponents
    gpsEligible
    status
    image
    sku
    associatedProductBrand
    associatedProductName
    circularEconomy
    climateHealth
    ecosystemHealth
    humanHealth
    socialHealthEquity
  }
`;
r`
  query MaterialExportQuery($boardId: UUID!, $itemIds: [UUID!]) {
    MaterialExport(boardId: $boardId, itemIds: $itemIds) {
      projectInfo {
        ...ProjectInfoFields
      }
      rows {
        ...RowFields
      }
    }
  }
  ${fe}
  ${ge}
`;
r`
  query PublicMaterialExportQuery($token: String!, $itemIds: [UUID!]) {
    PublicMaterialExport(token: $token, itemIds: $itemIds) {
      projectInfo {
        ...ProjectInfoFields
      }
      rows {
        ...RowFields
      }
    }
  }
  ${fe}
  ${ge}
`;
r`
  query MaterialExportTemplatesQuery {
    MaterialExportTemplates {
      id
      name
      type
      items {
        key
        isActive
        position
      }
    }
  }
`;
r`
  query MoodboardComments($threadId: UUID!) {
    MoodboardComments(threadId: $threadId) {
      id
      comment
      createdAt
      updatedAt
      user {
        userRef
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
r`
  query MoodboardDetailsQuery($id: UUID!) {
    Moodboard(id: $id) {
      id
      name
      payload
    }
  }
`;
r`
  query PinterestPinsOnBoard(
    $accessToken: String!
    $boardID: String!
    $params: PinterestListParams
  ) {
    PinterestPinsOnBoard(
      accessToken: $accessToken
      boardID: $boardID
      params: $params
    ) {
      bookmark
      items {
        id
        title
        media
      }
    }
  }
`;
r`
  query PinterestBoards($accessToken: String!, $params: PinterestListParams) {
    PinterestBoards(accessToken: $accessToken, params: $params) {
      bookmark
      items {
        id
        name
        pinCount
        media
        owner {
          username
        }
      }
    }
  }
`;
r`
  query ProjectBoardsItemsQuery($filter: BoardFilterInput, $limit: Int) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
      slug
      sampledBrandsSummary {
        total
        specified
        excluded
        considering
      }
    }
  }
`;
r`
  query ProjectBoardsQuery($filter: BoardFilterInput, $limit: Int) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
    }
  }
`;
r`
  query ProjectBoardsQuery(
    $filter: BoardFilterInput
    $limit: Int
    $sampledBrandsLimit: Int
    $sampledBrandsFilter: SampledBrandFilterInput
  ) {
    Boards(filter: $filter, limit: $limit) {
      id
      projectRef
      slug
      sampledBrands(limit: $sampledBrandsLimit, filter: $sampledBrandsFilter) {
        status
        name
        logo
      }
    }
  }
`;
r`
  query SampledBrandsBoardQuery($slug: String!) {
    Board(slug: $slug) {
      id
      sampledBrands {
        name
        logo
        status
      }
    }
  }
`;
r`
  query UserTagsQuery {
    Tags {
      id
      name
    }
  }
`;
r`
  subscription WatchBoardSummary($boardId: UUID!) {
    watchBoardSummary(boardId: $boardId) {
      boardId
      itemNotes {
        itemID
        hasNewNotes
        notesCount
      }
    }
  }
`;
r`
  subscription ItemNotesSubscribe($itemId: UUID!) {
    watchItemNotes(itemId: $itemId) {
      type
      note {
        id
        isPublic
        note
        user {
          firstName
          lastName
          imageUrl
          userRef
        }
        updatedAt
        createdAt
      }
    }
  }
`;
r`
  subscription MoodboardCommentsSubscription(
    $moodboardId: UUID!
    $threadId: UUID!
  ) {
    watchMoodboardComments(moodboardId: $moodboardId, threadId: $threadId) {
      type
      comment {
        id
        comment
        createdAt
        updatedAt
        user {
          userRef
          firstName
          lastName
          imageUrl
        }
      }
    }
  }
`;
r`
  subscription MoodboardSummarySubscription($moodboardId: UUID!) {
    watchMoodboardSummary(moodboardId: $moodboardId) {
      comments {
        commentsCount
        threadId
        lastComment {
          id
          comment
          createdAt
          updatedAt
          user {
            userRef
            firstName
            lastName
            imageUrl
          }
        }
      }
    }
  }
`;
const $e = "boards.accessToken", Ie = (e) => {
  const t = e.split(".").pop() || "";
  return JSON.parse(atob(t))?.expiresAt || "";
}, St = (e) => {
  const t = Ie(e), o = (/* @__PURE__ */ new Date()).toISOString();
  return new Date(t) < new Date(o);
}, Ut = (e) => {
  try {
    const t = Ie(e);
    let o = 0;
    if (t) {
      const a = (/* @__PURE__ */ new Date()).toISOString();
      o = oe(t, new Date(a));
    }
    return o < 5;
  } catch {
    return !0;
  }
};
function N(e, t) {
  S.setItem(
    $e,
    JSON.stringify({
      [t]: e
    })
  );
}
const wt = () => S.getItem(K) ? JSON.parse(S.getItem(K))?.customer?.signin_token : "";
function Dt() {
  try {
    return JSON.parse(S.getItem($e) ?? "{}");
  } catch {
    return {};
  }
}
const V = "private-content-loaded", be = async (e) => {
  let t = wt();
  return t || (t = await new Promise((o) => {
    const a = (s) => {
      const u = s;
      window.removeEventListener(V, a);
      const c = u.detail.data;
      o(c.customer.signin_token);
    };
    window.addEventListener(V, a);
  })), fetch(e, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      query: `
        query Auth($exToken: String!) {
          Auth(exToken: $exToken) {
            token
          }
        }
      `,
      variables: {
        exToken: t
      }
    })
  });
}, _t = async (e, t) => {
  try {
    const s = (await (await be(e)).json()).data.Auth?.token || "";
    return N(s, t), s;
  } catch (o) {
    return console.error(o), "";
  }
}, Pt = (e, t) => {
  be(e).then(
    (o) => {
      o.json().then((a) => {
        const s = a.data.Auth?.token || "";
        N(s, t);
      });
    },
    (o) => {
      console.error(o), N("", t);
    }
  );
}, Ct = () => {
  const e = window.location.hostname;
  return G[e] ?? G.default;
}, Ft = `${Ct()}/api/v1/query`, O = `${pt()}/api/v1/query`, P = "apollo-client-cache", Tt = ct, Mt = It;
var ye = /* @__PURE__ */ ((e) => (e.PROJECT = "projectOperations", e.BOARD = "boardOperations", e))(ye || {});
const At = {
  projectOperations: Tt,
  boardOperations: Mt
}, D = {
  projectOperations: O,
  boardOperations: Ft
};
function Et(e) {
  const o = e?.query?.definitions.find(
    (s) => s.kind === "OperationDefinition"
  );
  return (
    // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
    o?.selectionSet?.selections?.[0]?.kind === "Field" ? (
      // @ts-ignore ignoring due to tsc not being able to infer the type of operationDefinition in each application
      o.selectionSet.selections[0].name.value
    ) : void 0
  );
}
function _(e) {
  const t = Et(e);
  return t ? Object.values(ye).find(
    (o) => At[o].includes(t)
  ) ?? null : null;
}
function C(e, t) {
  if (!t)
    return e;
  const o = _(t);
  return o ? D[o] : e;
}
const he = {
  projectOperations: {
    getAccessTokenFromStorage: lt,
    createToken: mt,
    refreshToken: ut,
    shouldRefresh: Ze,
    isExpired: Xe
  },
  boardOperations: {
    getAccessTokenFromStorage: Dt,
    createToken: _t,
    refreshToken: Pt,
    shouldRefresh: Ut,
    isExpired: St
  }
}, Rt = () => (window[P] || (window[P] = new Ue()), window[P]);
function ke(e) {
  return new Re({
    link: e,
    cache: Rt()
  });
}
function jt({ buildUri: e, defaultUri: t }) {
  const [o, a] = xe(null), s = async (i, n) => {
    let d = null;
    if (n ? d = n : i && (d = _(i)), !d)
      return "";
    const m = he[d];
    let B = m.getAccessTokenFromStorage();
    const $ = await ie();
    let l = B[$];
    return (!l || m.isExpired(l)) && (l = await m.createToken(
      e(t, i),
      $
    )), m.shouldRefresh(l) && m.refreshToken(e(t, i), $), `Bearer ${l}`;
  }, u = re({
    uri: (i) => e(t, i)
  }), c = T(async (i, { headers: n }) => ({ headers: { ...n, "Accept-Language": ne() || "en" } })), g = Object.keys(D).reduce(
    (i, n) => (i[n] = new Z(
      ee({
        url: D[n],
        connectionParams: async () => ({
          Authorization: await s(
            void 0,
            n
          )
        }),
        retryAttempts: 5
      })
    ), i),
    {}
  ), b = (i) => g[_(i) || ""], y = T(async (i, { headers: n }) => {
    if (!se())
      return n;
    const d = await s(i);
    return {
      headers: {
        ...n,
        authorization: d ?? ""
      }
    };
  }), k = new Y((i) => b(i).request(i)), f = X(
    ({ query: i }) => {
      const n = te(i);
      return n.kind === "OperationDefinition" && n.operation === "subscription";
    },
    k,
    // Send subscription operations through the WebSocket
    y
    // Send queries/mutations through the HTTP link
  );
  return Ne(() => {
    a(ke(R([c, f, u])));
  }, []), {
    client: o,
    generateBearerToken: s
  };
}
function rr({ children: e }) {
  const { client: t } = jt({ buildUri: C, defaultUri: O });
  return t ? /* @__PURE__ */ je(we, { client: t, children: e }) : null;
}
async function xt(e = {}) {
  const {
    defaultUri: t = O,
    enableSubscriptions: o = !0,
    enableAuth: a = !0
  } = e, s = async (i, n) => {
    if (!a)
      return "";
    let d = null;
    if (n ? d = n : i && (d = _(i)), !d)
      return "";
    const m = he[d];
    let B = m.getAccessTokenFromStorage();
    const $ = await ie();
    let l = B[$];
    return (!l || m.isExpired(l)) && (l = await m.createToken(
      C(t, i),
      $
    )), m.shouldRefresh(l) && m.refreshToken(C(t, i), $), `Bearer ${l}`;
  }, u = re({
    uri: (i) => C(t, i)
  }), c = T(async (i, { headers: n }) => {
    const d = ne() || "en";
    return { headers: { ...n, "Accept-Language": d } };
  });
  let g = {}, b = null;
  if (o) {
    g = Object.keys(D).reduce(
      (n, d) => (n[d] = new Z(
        ee({
          url: D[d],
          connectionParams: async () => ({
            Authorization: await s(
              void 0,
              d
            )
          }),
          retryAttempts: 5
        })
      ), n),
      {}
    );
    const i = (n) => g[_(n) || ""];
    b = new Y((n) => i(n).request(n));
  }
  const y = T(async (i, { headers: n }) => {
    if (!a || !se())
      return n;
    const d = await s(i);
    return {
      headers: {
        ...n,
        authorization: d ?? ""
      }
    };
  });
  let k;
  if (o && b) {
    const i = X(
      ({ query: n }) => {
        const d = te(n);
        return d.kind === "OperationDefinition" && d.operation === "subscription";
      },
      b,
      // Send subscription operations through WebSocket
      y
      // Send queries/mutations through HTTP
    );
    k = R([c, i, u]);
  } else
    k = R([c, y, u]);
  return ke(k);
}
let F = null;
async function or(e = {}) {
  return F || (F = await xt(e)), F;
}
function ar() {
  F = null;
}
class Nt {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(t) {
    this.client = t;
  }
  /**
   * Execute a GraphQL query
   */
  async query(t, o, a) {
    return this.client.query({
      query: t,
      variables: o,
      ...a
    });
  }
  /**
   * Execute a GraphQL mutation
   */
  async mutate(t, o, a) {
    return this.client.mutate({
      mutation: t,
      variables: o,
      ...a
    });
  }
  /**
   * Subscribe to a GraphQL subscription
   * Returns an observable that can be subscribed to
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscribe(t, o) {
    return this.client.subscribe({
      query: t,
      variables: o
    });
  }
  /**
   * Clear the Apollo Client cache
   */
  async clearCache() {
    await this.client.clearStore();
  }
  /**
   * Reset the Apollo Client cache and refetch all active queries
   */
  async resetCache() {
    await this.client.resetStore();
  }
  /**
   * Write data directly to the cache
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  writeQuery(t, o, a) {
    this.client.writeQuery({
      query: t,
      data: o,
      variables: a
    });
  }
  /**
   * Read data from the cache
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readQuery(t, o) {
    try {
      return this.client.readQuery({
        query: t,
        variables: o
      });
    } catch {
      return null;
    }
  }
  /**
   * Get the underlying Apollo Client instance
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getClient() {
    return this.client;
  }
}
function ir(e) {
  return new Nt(e);
}
export {
  P as APOLLO_CACHE_WINDOW_KEY,
  dr as ApolloConsumer,
  cr as ApolloError,
  rr as ApolloProvider,
  lr as BaseApolloProvider,
  mr as NetworkStatus,
  ye as OperationType,
  ke as buildClient,
  C as buildUri,
  xt as createVanillaApolloClient,
  ir as createVanillaUtils,
  _ as getOperationType,
  Et as getQueryNode,
  or as getVanillaApolloClient,
  ur as gql,
  O as projectsUri,
  ar as resetVanillaApolloClient,
  he as tokenGeneration,
  D as uriByOperationType,
  jt as useApolloClient,
  pr as useApolloClientHook,
  fr as useLazyQuery,
  gr as useMutation,
  $r as useQuery,
  Ir as useSubscription
};
